import { Row } from 'antd';
import { useTheme } from 'styled-components';
import { NotificationHistory } from '../../../2_domain/notification/notification';
import Column from '../../core/components/box/column';
import SizedBox from '../../core/components/box/sizedBox';
import { LXCaption, LXh4 } from '../../core/texts/lxText';

interface DescriptionProps {
  item: NotificationHistory;
}
const Description = ({ item }: DescriptionProps) => {
  const theme = useTheme();

  const msg = {
    ICON_BELL: theme.texts.testResultsHaveArrived,
    ICON_WALLET: theme.texts.orderHasBeenCompleted,
  };

  return (
    <Column justifyContent="flex-end">
      <Row>
        <LXh4>{`#${item.testSerial}`}</LXh4>
        &nbsp;
        <LXh4 fontWeight={400}>{`${msg[item.iconKind]}`}</LXh4>
      </Row>
      <SizedBox height={4} />
      <LXCaption>{`${item.testName} / ${item.clinicName}`}</LXCaption>
    </Column>
  );
};

export default Description;
